"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useScrollToElement: true
};
exports.useScrollToElement = void 0;
var _react = require("react");
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});
var useScrollToElement = function useScrollToElement(elementRef) {
  var scrollToElement = (0, _react.useCallback)(function () {
    if (elementRef.current) {
      elementRef.current.scrollIntoView();
      window.scrollBy(0, -_constants.MENU_HEIGHT - _constants.SCROLL_OFFSET);
    }
  }, [elementRef]);
  return scrollToElement;
};
exports.useScrollToElement = useScrollToElement;